import React from 'react'
import dayjs from 'dayjs'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMap from 'highcharts/modules/map'
import * as Exporting from 'highcharts/modules/exporting'
import * as OfflineExport from 'highcharts/modules/offline-exporting'
import { useGeoState } from '../GeoProvider'
import Spinner from '../Loader/Spinner'
import getMapOptions from './getMapOptions'
import MapBordercolor from '../../utils/MapBordercolor'
import usStateDummy from './dummyStats'
import usStateAll from './usStatesAll'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import CountingMethod from './../../utils/getCountingMethod'
function isEmptyObject(obj) {
  return JSON.stringify(obj) === '{}'
}

const Map = ({
  toolTipFormatter,
  activeCbsasData,
  statesData,
  cbsaData,
  mapOptions,
  showStateLabels,
  showCbsaLabels,
  enableTooltip,
  enableMapNavigation,
  enableMouseTracking,
  mapHeight = '70vh',
  mapWidth = '',
  mapTitleDisable,
  mapType,
  enableButtons = false,
  zoomLocation = '',
  chartRef,
  mapDataType,
  JsonData,
  stateJson,
  countyGeoJson,
  dashboardType,
  zip3Json,
  zip3Data,
  countyData,
  activeZip3Data,
  highlightCBSA = false,
  exportMap = false,
  showCountyLabels,
  posTrue=false,
  enableMouseZoom=false
}) => {
  if (typeof Highcharts === 'object') {
    HighchartsMap(Highcharts)
  }
  const { displayDate,diseaseSelectedSurv, regionSelected,getRefreshDateFilter } = useGeoState()
  if (exportMap) {
    Exporting(Highcharts)
    OfflineExport(Highcharts)
  }
  const history = useNavigate()
  let mapActiveCbsaData = null
  let mapActiveZIP3Data = null
  let mapStatesData = null
  let mapCbsaData = null
  let mapMsaData = null
  let mapCountyData=null
  let zip3DataFiltered = null
  let statesDataForDisplayDate = null
  let survColorAxis=null
  const sundayDate = dayjs().day(0).format('YYYY-MM-DD')

   function getIntervalThreshold(min,max,num)
  {
    let diff=max-min
    let diffValue=diff/5

    return parseFloat(((diffValue*num)+min).toFixed(3));
  }
  function getRangeFromThreshold(min,max,num)
  {
    let diff=max-min
    let diffValue=diff/5
    let finalValue=((diffValue*num)+min)
    let rtValue=finalValue<.001?finalValue:finalValue+.001
    return parseFloat(rtValue.toFixed(3));
  }
  function getSurvColorAxis(dataSet)
  {
  let minData=Math.min(...dataSet.map(member => member[1].data_value))
  let maxData=Math.max(...dataSet.map(member => member[1].data_value))
    let cAxis={
      dataClasses: [
        {
          to: 0,
          color: '#6D6F70',
          name: 'No Data',
        },
        {
          from: 0.001,
          to: getIntervalThreshold(minData,maxData,1),
          color: '#E5FCF6',
           plotBorderColor: '#2B9181',
          borderWidth: 5,
          name: getIntervalThreshold(minData,maxData,1)
          ,
        },
        {
          from: getRangeFromThreshold(minData,maxData,1),
          to: getIntervalThreshold(minData,maxData,2),
          color: '#ACCAE4',
          plotBorderColor: '#2D6EA3',
          borderWidth: 1,
          name: getIntervalThreshold(minData,maxData,2),
        },
        {
          from: getRangeFromThreshold(minData,maxData,2),
          to: getIntervalThreshold(minData,maxData,3),
          color: '#7B99CD',
          plotBorderColor: '#0E456B',
          borderWidth: 1,
          name: getIntervalThreshold(minData,maxData,3),
        },
        {
          from: getRangeFromThreshold(minData,maxData,3),
          to: getIntervalThreshold(minData,maxData,4),
          color: '#5768B0',
          plotBorderColor: '#FFFFFF',
          borderWidth: 1,
          name: getIntervalThreshold(minData,maxData,4),
        },
        {
          from: getRangeFromThreshold(minData,maxData,4),
          color: '#48338C',
          plotBorderColor: '#FFFFFF',
          borderWidth: 1,
          name: getIntervalThreshold(minData,maxData,5),
        },
      ],
    }
    let cAxisNoData={dataClasses: [
      {
        to: 0,
        color: '#6D6F70',
        name: 'No Data',
      }]}
    return (minData===0&& maxData===0)?cAxisNoData:cAxis
  }
  function getDynamicColorLegend(posId,diseaseId,dashType,region)
  {
 
    if(dashType==='SURV')
    {
      return false
      // if(region.toUpperCase()==='ZIP3')
      //   {  return true}
      // else{  return false}
    
      // if((diseaseId.toUpperCase()==='FLU'))
      // {
      //   if(posId.toString()!=="0")
      //   {
      //     return true
      //   }
      //   else{
      //     return false
      //   }
      // }
      // else if((
      // diseaseId.toUpperCase()==='COVID-19' || 
      // diseaseId.toUpperCase()==='RSV'))
      // {
      //   if(posId.toString()!=="0")
      //   {
      //     return true
      //   }
      //   else{
      //     if(region.toUpperCase()==='ZIP3')
      //     {return true}
      //     else{
      //     return false
      //     }
      //   }
      // }
      // else{
      //   return true
      // }

    }
    else{
      return false
    }

  }
  function getBorderColorSurv(dataSet,data_value){
    let minData=Math.min(...dataSet.map(member => member[1].data_value))
    let maxData=Math.max(...dataSet.map(member => member[1].data_value))
    if(minData===0 && maxData===0)
    {return '#FFFFFF'}
    if(data_value>=.001 && data_value<=getIntervalThreshold(minData,maxData,1))
    {
      return '#2B9181'
    }
    else if(data_value>=getRangeFromThreshold(minData,maxData,1) && data_value<=getIntervalThreshold(minData,maxData,2))
    {
      return '#2D6EA3'
    }
    else if(data_value>=getRangeFromThreshold(minData,maxData,2) && data_value<=getIntervalThreshold(minData,maxData,3))
    {
      return '#0E456B'
    }
    else if(data_value>=getRangeFromThreshold(minData,maxData,3) && data_value<=getIntervalThreshold(minData,maxData,4))
    {
      return '#FFFFFF'
    }
    else if(data_value>=getRangeFromThreshold(minData,maxData,4))
    {
      return '#FFFFFF'
    }
    else
    {
      return '#FFFFFF'
    }
  }

  if (
    mapType === 'rsvmap' ||
    mapType === 'rsvmapmsa' ||
    mapType === 'rsvmapcdo' ||
    mapType === 'zip3map' ||
     mapType==='countymap'||
    mapType==='countymapmsa'
  ) {
    if (mapType === 'zip3map' || mapType==='countymap') {
      var datacount = Object.keys(statesData).length - 1
      let lastData = Object.keys(statesData).sort()[datacount]
      if (displayDate > lastData) {
        statesDataForDisplayDate = Object.entries(usStateDummy)
      } else {
        statesDataForDisplayDate = Object.entries(statesData[displayDate])
      }
    } else {
      statesDataForDisplayDate = Object.entries(statesData[displayDate])
    }
    let dataSet=statesDataForDisplayDate
    survColorAxis=getSurvColorAxis(dataSet)
    mapStatesData = statesDataForDisplayDate.map((state) => {    
      if(getDynamicColorLegend(posTrue,diseaseSelectedSurv,dashboardType,regionSelected))
      {
        
        return {
        value:state[1][mapOptions.tagValue],
        state: state[0],
        borderColor:getBorderColorSurv(dataSet,state[1].data_value),
        ...state[1],
      }}
      else{
       const value = state[1][mapOptions.value]; // Get the value from the state
       const dataClass = mapOptions.colorAxis.dataClasses[value];
      
      return {
        value: state[1][mapOptions.value],
        state: state[0],
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff', // Use default color if dataClass is undefined 
     // borderColor:  mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,       
        ...state[1],    
      }
    }
    })   
    let mapstates=mapStatesData.map(item => item.state)

     if(usStateAll.length>mapstates.length && dashboardType.toLowerCase()==='meningitis')
     {
      usStateAll.map((obj)=>{
      if(!mapstates.includes(obj.value))
      {
        mapStatesData.push({
         "data_value": 0,
         "value": 0,
        "state": obj.value,
        "borderColor": "",
        "geo_type": "STATE",
        "geo_id": obj.value,
        "geo_name": obj.label,
        "geo_parent": "US",
        "year":  moment(displayDate).format('YYYY'),
        "month":  moment(displayDate).format('MMMM'),
        "forecast_level": 0,
        "week_ending": moment(displayDate).format('MM-DD-YYYY')
    }
        )
      }
    })
  }
  if(usStateAll.length>mapstates.length && dashboardType.toLowerCase()==='birthtrend')
     {
      usStateAll.map((obj)=>{
      if(!mapstates.includes(obj.value))
      {
        mapStatesData.push({
         "value": 0,
        "state": obj.value,
        "borderColor": "",
        "geo_type": "STATE",
        "geo_id": obj.value,
        "geo_name": obj.label,
        "geo_parent": "US",
        "year":  moment(displayDate).format('YYYY'),
        "month":  moment(displayDate).format('MMMM'),
        "rate_per_100k": "0",
        "threshold": "No Data",
        "threshold_level": 0,
        "week_ending": moment(displayDate).format('MMMM YYYY'),
        "rate_change_pct": "-1.26",
        "month_date":  moment(displayDate).format('YYYY-MM-DD')
    }
        )
      }
    })
  }
  }
  if (mapType === 'zip3map' && zip3Data && !isEmptyObject(zip3Data)) {
    const zip3DataForDisplayDate = Object.entries(zip3Data[displayDate])
   
      
    zip3DataFiltered = zip3DataForDisplayDate.map((state) => {
    const value = state[1][mapOptions.value]; // Get the value from the state
    const dataClass = mapOptions.colorAxis.dataClasses[value];
      return {
        value: state[1][mapOptions.value],
        state: state[0],
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff', 
       // borderColor: mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,                
        ...state[1],
      }
    })
    mapActiveZIP3Data = activeZip3Data.map((zip3) => {
      return zip3.toString()
    })
  }
  if (mapType === 'countymapmsa' && countyData && !isEmptyObject(countyData)) {
    const countyDataForDisplayDate = Object.entries(countyData[displayDate])
    mapCountyData = countyDataForDisplayDate.map((state) => {
      return {
        value: state[1][mapOptions.value],
        state: state[0],
        borderColor: mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,                
        ...state[1],
      }
    })
    mapActiveZIP3Data = activeCbsasData.map((cbsa) => {
      return cbsa.toString()
    })

    let mapcounties=mapCountyData.map(item => item.state)

      activeCbsasData.map((obj,index)=>{
      if(!mapcounties.includes(obj))
      {
        const featureObj = countyGeoJson.features.find(
          (f) => f.properties.geoid === obj
          )
        mapCountyData.push({
         "value": 0,
          "state": featureObj!==undefined?featureObj.properties.geoid:obj,
          "borderColor": "",
          "geo_type": "STATE",
          "geo_id": featureObj!==undefined?featureObj.properties.geoid:obj,
          "geo_name": featureObj!==undefined?featureObj.properties.NAME:obj,
          "geo_parent":featureObj!==undefined?featureObj.properties.STUSPS:'US',
          "year":  moment(displayDate).format('YYYY'),
          "month":  moment(displayDate).format('MMMM'),
          "rate_per_100k": "0",
          "threshold": "No Data",
          "threshold_level": 0,
          "week_ending": moment(displayDate).format('MMMM YYYY'),
          "rate_change_pct": "-1.26",
          "month_date":  moment(displayDate).format('YYYY-MM-DD')
    }
        )
      }
    })
  // }
      

    
  }
  if (mapType === 'countymap' && countyData && !isEmptyObject(countyData)) {
    const zip3DataForDisplayDate = Object.entries(countyData[displayDate])
    mapCountyData = zip3DataForDisplayDate.map((state) => {
      return {
        value: state[1][mapOptions.value],
        state: state[0],
        borderColor: mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,                
        ...state[1],
      }
    })
    mapActiveCbsaData = activeCbsasData.map((zip3) => {
      return zip3.toString()
    })
  }
  if (
    (mapType === 'rsvmapmsa' && cbsaData && !isEmptyObject(cbsaData)) ||
    (mapType === 'rsvmapcdo' && cbsaData && !isEmptyObject(cbsaData))
  ) {
    const cbsaDataForDisplayDate = Object.entries(cbsaData[displayDate])
    mapCbsaData = cbsaDataForDisplayDate.map((cbsa) => {
    const value = cbsa[1][mapOptions.value]; // Get the value from the state
    const dataClass = mapOptions.colorAxis.dataClasses[value];
      return {
        value: cbsa[1][mapOptions.value],
        state: cbsa[0].toString(),
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff', 
        //borderColor: mapOptions.colorAxis.dataClasses[cbsa[1][mapOptions.value]].plotBorderColor,
        
        ...cbsa[1],
      }
    })
    mapActiveCbsaData = activeCbsasData.map((cbsa) => {
      return cbsa.toString()
    })
  }
 else if (mapType !== undefined && mapType.toUpperCase() === 'COVERAGEMAP') {
    const stateDateData = Object.entries(statesData[sundayDate])
    mapStatesData = stateDateData.map((state) => {
      return {
        value: state[1].MR!==undefined?state[1].MR[mapOptions.value]:0,
        state_per: state[1].MR!==undefined?state[1].MR[mapOptions.lobPer]:0,
        state_count: state[1].MR!==undefined?state[1].MR[mapOptions.stateCount]:0,
        mr: state[1].MR!==undefined?state[1].MR[mapOptions.lobValue]:0,
        mr_per: state[1].MR!==undefined?state[1].MR[mapOptions.lobPer]:0,
        ei: state[1].EI!==undefined?state[1].EI[mapOptions.lobValue]:0,
        ei_per: state[1].EI!==undefined?state[1].EI[mapOptions.lobPer]:0,
        cs: state[1].CS!==undefined?state[1].CS[mapOptions.lobValue]:0,
        cs_per: state[1].CS!==undefined?state[1].CS[mapOptions.lobPer]:0,
        population: CountingMethod(state[1].MR!==undefined?state[1].MR[mapOptions.popCount]:0, 'fixed'),
        state: state[0],
        ...state[1].MR!==undefined?state[1].MR:{},
      }
    })
  }
  let title = mapOptions.mapTitle
  if (!(title === null || title === undefined)) {
    title = ''
  }

  const graphOptions = getMapOptions(
    getDynamicColorLegend(posTrue,diseaseSelectedSurv,dashboardType,regionSelected)?survColorAxis:mapOptions.colorAxis, 
    mapOptions.legend,
    toolTipFormatter,
    mapActiveCbsaData,
    mapCbsaData,
    mapStatesData,
    mapMsaData,
    history,
    mapType,
    enableButtons,
    zoomLocation,
    mapDataType,
    JsonData,
    stateJson,
    mapCountyData,
    countyGeoJson,
    dashboardType,
    title,
    mapOptions.mapSubTitle,
    showStateLabels,
    showCbsaLabels,
    enableTooltip,
    enableMapNavigation,
    enableMouseTracking,
    zip3Json,
    zip3DataFiltered,
    mapActiveZIP3Data,
    highlightCBSA,
    exportMap,
    showCountyLabels,
    enableMouseZoom
  )

  return mapOptions ? (
    <>
      <HighchartsReact
        containerProps={{
          style: {
            height: mapHeight,
            width: mapWidth,
            margin: '0 auto',
            position: 'relative',
            display: 'flex',
          },
        }}
        constructorType="mapChart"
        highcharts={Highcharts}
        options={graphOptions}
        allowChartUpdate
        updateArgs={[true, true, false]}
        ref={chartRef}
      />
    </>
  ) : (
    <Spinner />
  )
}
export default Map